import { parsePhoneNumberFromString } from 'libphonenumber-js'

// Each digit is the previous one plus `step`, wrapping 9→0 (so 1234567890 and
// 9876543210 both count).
function isDigitRun(digits, step) {
	for (let i = 1; i < digits.length; i++) {
		if ((Number(digits[i - 1]) + step + 10) % 10 !== Number(digits[i])) {
			return false
		}
	}
	return true
}

// Catches the obvious made-up numbers that still pass format validation.
// Only NANP 555-01XX is reserved as fictional; other 555 numbers can be real.
export function isPlausiblePhone(e164) {
	const parsed = parsePhoneNumberFromString(String(e164 || ''))
	if (!parsed) return false
	const nsn = parsed.nationalNumber
	if (/^(\d)\1+$/.test(nsn)) return false
	if (isDigitRun(nsn, 1) || isDigitRun(nsn, -1)) return false
	if (parsed.countryCallingCode === '1' && /^\d{3}55501\d{2}$/.test(nsn)) {
		return false
	}
	return true
}
